module.exports = __webpack_public_path__ + "static/media/WhatsApp Image 2026-08-05 at 10.38.59.ecfeaf13.jpeg";